export default "__VITE_ASSET__BT_JY$Mi__"